import academicCalender from '../../downloads/pdf/Academic Calender.pdf';
import activitiesCompetitions from '../../downloads/pdf/Activities and Competitions.pdf';
import affidavit from '../../downloads/pdf/Affidavit.pdf';
import asm from '../../downloads/pdf/Annual Sports Meet.pdf';
import examSchedule from '../../downloads/pdf/Exam Schedule.pdf';
import holidayList from '../../downloads/pdf/Holiday List.pdf';
import resultanal from '../../downloads/pdf/RESULTANAL.pdf';
import schoolUniform from '../../downloads/pdf/School Uniform.pdf';
import schoolInfo from '../../downloads/pdf/SchoolInfo.pdf';
import smc from '../../downloads/pdf/SMC.pdf';
import teachersList from '../../downloads/pdf/Teachers List.pdf';

let pdfObj = [
    {
        id: 1,
        name:'Academic Calender.pdf',
        link: academicCalender
    },{
        id: 2,
        name:'Activities and Competitions.pdf',
        link: activitiesCompetitions
    },{
        id: 3,
        name:'Affidavit.pdf',
        link: affidavit
    },{
        id: 4,
        name:'Annual Sports Meet.pdf',
        link: asm
    },{
        id: 5,
        name:'Exam Schedule',
        link: examSchedule
    },{
        id: 6,
        name:'Holiday List.pdf',
        link: holidayList
    },{
        id: 7,
        name:'Resultanal.pdf',
        link: resultanal
    },{
        id: 8,
        name:'School Uniform.pdf',
        link: schoolUniform
    },{
        id: 9,
        name:'School Info.pdf',
        link: schoolInfo
    },{
        id: 10,
        name:'SMC.pdf',
        link: smc
    },{
        id: 11,
        name:'Teachers List.pdf',
        link: teachersList
    },
]

export default pdfObj;